<script setup>
defineProps({ rows: { type: Number, default: 4 }, compact: { type: Boolean, default: false } })
</script>
<template>
  <div class="animate-pulse space-y-3" aria-busy="true" aria-label="Загрузка">
    <div v-for="row in rows" :key="row" class="rounded-app-control bg-slate-200/70" :class="compact ? 'h-10' : 'h-20'"></div>
  </div>
</template>
